<template>
  <el-card v-loading="loading" class="pro-detail">
    <el-row class="info">
      <el-form label-width="80" :inline="true">
        <el-row>
          <el-col :span="8">
            <el-form-item label="商户订单号:">
              {{ declareDetailInfo.originMerchantOrderNo }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="电商平台名称:">
              {{ declareDetailInfo.ePlatformEnterprise.enterpriseCustomsName }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="电商企业名称:">
              {{ declareDetailInfo.eEnterprise.enterpriseCustomsName }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="跨境模式:">
              {{ declareDetailInfo.crossType }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="申报口岸:">
              {{ declareDetailInfo.portNidDesc }}
              <!--                            <el-button size="mini" type="primary">更换申报口岸</el-button>-->
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="订单总金额:">
              {{ declareDetailInfo.paymentInfo.goodsTotalAmount }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="优惠券金额:">
              {{ declareDetailInfo.paymentInfo.discountAmount }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="总税金:">
              {{ declareDetailInfo.paymentInfo.taxAmount }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="支付金额:">
              {{ declareDetailInfo.paymentInfo.tradeAmount }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="订单支付时间:">
              {{ declareDetailInfo.gmtMerchantPaid }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="下单时间:">
              {{ declareDetailInfo.gmtMerchantCreate }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="清单申报时间:">
              {{ declareDetailInfo.ccbDeclareGmtPass }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="清单申报状态:">
              {{
                declareDetailInfo.ccbBizState == null
                  ? "未回执" // eslint-disable-next-line vue/no-parsing-error
                  : parseInt(declareDetailInfo.ccbBizState) <= 0
                  ? "异常"
                  : declareDetailInfo.ccbBizRemark
              }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-row>
    <!-- 收货人信息 -->
    <el-alert
      v-if="false"
      class="info-title"
      title="收货人信息"
      type="info"
      :closable="false"
    >
    </el-alert>
    <el-row class="info" v-if="false">
      <el-form label-width="80" :inline="true">
        <el-row>
          <el-col :span="12">
            <el-form-item label="收货人姓名:">
              {{ declareDetailInfo.consigneeInfo.consigneeName }}
            </el-form-item>
          </el-col>
          <el-col class="address" :span="16">
            <el-form-item label="收货地址:">
              {{ declareDetailInfo.consigneeInfo.addrProvince }}
              {{ declareDetailInfo.consigneeInfo.addrCity }}
              {{ declareDetailInfo.consigneeInfo.addrDistrict }}
              {{ declareDetailInfo.consigneeInfo.addrDetail }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-row>

    <!-- 支付信息 -->
    <el-alert class="info-title" title="支付信息" type="info" :closable="false">
    </el-alert>
    <el-row class="info">
      <el-form label-width="80" :inline="true">
        <el-row>
          <el-col :span="4">
            <el-form-item label="支付金额:">
              {{ declareDetailInfo.paymentInfo.tradeAmount }}
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="支付时间:">
              {{ declareDetailInfo.gmtMerchantPaid }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-row>

    <!-- 仓储信息 -->
    <el-alert class="info-title" title="仓储信息" type="info" :closable="false">
    </el-alert>
    <el-row class="info">
      <el-form label-width="80" :inline="true">
        <el-row>
          <el-col :span="8">
            <el-form-item label="发货仓:">
              {{ declareDetailInfo.warehouseCodeDesc }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="物流承运商:">
              {{ declareDetailInfo.carrierCodeDesc }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="快递单号:">
              {{ declareDetailInfo.mailNo }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-row>

    <!-- 商品信息 -->
    <el-alert class="info-title" title="商品信息" type="info" :closable="false">
    </el-alert>
    <el-row class="info">
      <element-table
        headerClassName="stock-table"
        :data="declareDetailInfo.items"
        :columns="skuListColumns"
        :loading="loading"
        border
      ></element-table>
    </el-row>
  </el-card>
</template>

<script>
import ElementTable from "@/components/ElementTable";
import { formatDate } from "@/utils/common";
import { CONST_VD_IMGPREFIX } from "@/config/constant";

export default {
  data() {
    return {
      env: CONST_VD_IMGPREFIX.env,
      bizId: this.$route.params.id,
      loading: false,
      skuListColumns: [
        {
          title: "商品料号",
          key: "goodsItemNo",
          minWidth: 160,
          align: "center",
        },
        {
          title: "商品名称",
          key: "goodsName",
          minWidth: 160,
          align: "center",
        },
        {
          title: "商品条码",
          key: "barcode",
          minWidth: 130,
          align: "center",
        },
        {
          title: "数量",
          key: "quantity",
          width: 100,
          align: "center",
        },
        {
          title: "单价",
          key: "unitAmount",
          width: 100,
          align: "center",
        },
        {
          title: "折扣金额",
          key: "discountAmount",
          width: 100,
          align: "center",
        },
        {
          title: "总价",
          key: "actualAmount",
          width: 100,
          align: "center",
        },
      ],
      declareDetailInfo: {
        eEnterprise: {},
        ePlatformEnterprise: {},
        declareEnterprise: {},
        paymentInfo: {},
        payerInfo: {},
        consigneeInfo: {},
        ccbBizState: undefined,
      },
      region: {
        provinces: [],
        cities: [],
        areas: [],
      },
    };
  },
  components: {
    ElementTable,
  },
  watch: {
    $route(to, from) {
      if (to.name === "customerDeclareOrderDetail") {
        this.bizId = this.$route.params.id;
        this.fetch();
      }
    },
  },
  created() {
    this.bizId = this.$route.params.id;
    this.fetch();
  },
  mounted() {
    this.bizId = this.$route.params.id;
  },
  computed: {
    isShangHaiEnv() {
      return CONST_VD_IMGPREFIX.env === "SHANGHAI";
    },
  },
  methods: {
    // 获取入库单详情
    fetch() {
      this.loading = true;
      this.$store
        .dispatch("declareDetail", {
          bizId: this.bizId,
        })
        .then((res) => {
          this.declareDetailInfo = res;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    formatDate,
  },
};
</script>

<style lang="scss">
.pro-detail {
  .info-title {
    height: 64px;
    background: #f5f5f5;
    color: #17181a;
    // font-size: 20px;
    font-weight: bold;
  }

  .info {
    padding: 10px 20px 30px;

    .address {
      white-space: nowrap;

      .el-input {
        width: 33% !important;
      }
    }
  }

  .el-alert {
    margin-bottom: 10px;
  }

  .el-alert__title {
    font-size: 20px;
  }

  .el-alert__content {
    display: flex;
    width: 100%;
    justify-content: space-between;

    .tip {
      color: #ff3333;
    }
  }
}
</style>
